'use client';

import { c as _c } from "react/compiler-runtime";
import { type ComponentType, type PropsWithChildren, type ReactElement, useEffect, useState } from 'react';
import { useMounted } from '@shared/utils/hooks/use-mounted';
import { Button } from '../button/button';
import { type CustomDialogProps } from '../dialog/dialog';
import { ModalTrigger } from '../modal/modal';
import { InputPreview } from './components/input-preview/input-preview';
import styles from './account-settings-preview-modal.module.scss';
export type SectionsData = Array<{
  sectionItems: Array<{
    label: string;
    value: string;
  }>;
  sectionLinkComponent: ReactElement;
  sectionTitle: string;
}>;
type AccountSettingsPreviewModalProps = {
  cmsContent: {
    buttonLabel: string;
    contactSectionTitle: string;
    modalDescription: string;
    personalSectionTitle: string;
    professionalSectionTitle: string;
    title: string;
  };
  dialogComponent: ComponentType<Omit<CustomDialogProps, 'loader'>>;
  dismissModalHandler: () => void;
  initialIsModalOpen: boolean;
  sectionsData: SectionsData;
};
const FormPreviewSection = t0 => {
  const $ = _c(10);
  const {
    children,
    editLinkComponent,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <h3 className={styles["preview-modal__form-preview-section-title"]}>{title}</h3>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== editLinkComponent || $[3] !== t1) {
    t2 = <div className={styles["preview-modal__form-preview-section-heading"]}>{t1}{editLinkComponent}</div>;
    $[2] = editLinkComponent;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== children) {
    t3 = <dl className={styles["preview-modal__form-preview-items-list"]}>{children}</dl>;
    $[5] = children;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export const AccountSettingsPreviewModal = t0 => {
  const $ = _c(17);
  const {
    cmsContent,
    dialogComponent: Dialog,
    dismissModalHandler,
    initialIsModalOpen,
    sectionsData
  } = t0;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMounted = useMounted();
  let t1;
  if ($[0] !== initialIsModalOpen) {
    t1 = () => {
      if (initialIsModalOpen) {
        setIsModalOpen(true);
      }
    };
    $[0] = initialIsModalOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== initialIsModalOpen || $[3] !== isMounted) {
    t2 = [initialIsModalOpen, isMounted];
    $[2] = initialIsModalOpen;
    $[3] = isMounted;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== dismissModalHandler) {
    t3 = () => {
      dismissModalHandler();
      setIsModalOpen(false);
    };
    $[5] = dismissModalHandler;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleModalDismiss = t3;
  let t4;
  if ($[7] !== Dialog || $[8] !== cmsContent.buttonLabel || $[9] !== cmsContent.modalDescription || $[10] !== cmsContent.title || $[11] !== handleModalDismiss || $[12] !== sectionsData) {
    t4 = () => <Dialog className={styles["preview-modal"]} footer={<div className={styles["preview-modal__footer"]}><Button onClick={handleModalDismiss}>{cmsContent.buttonLabel}</Button></div>} hasCloseButton={false} title={cmsContent.title}><section className={styles["preview-modal__description-section"]}><p>{cmsContent.modalDescription}</p></section><section className={styles["preview-modal__form-preview-section"]}>{sectionsData && sectionsData.map(_temp2)}</section></Dialog>;
    $[7] = Dialog;
    $[8] = cmsContent.buttonLabel;
    $[9] = cmsContent.modalDescription;
    $[10] = cmsContent.title;
    $[11] = handleModalDismiss;
    $[12] = sectionsData;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== isModalOpen || $[15] !== t4) {
    t5 = <ModalTrigger isOpen={isModalOpen}>{t4}</ModalTrigger>;
    $[14] = isModalOpen;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};
function _temp(item) {
  return <InputPreview key={item.label + item.value} label={item.label} value={item.value} />;
}
function _temp2(sectionData) {
  if (sectionData.sectionItems.length) {
    return <FormPreviewSection editLinkComponent={sectionData.sectionLinkComponent} key={sectionData.sectionTitle} title={sectionData.sectionTitle}>{sectionData.sectionItems.map(_temp)}</FormPreviewSection>;
  }
  return null;
}